module.exports = __webpack_public_path__ + "img/showcase-icon1.beed108e.png";